import React, { memo, useState, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Package, Activity, ShoppingCart } from 'lucide-react';
import { marcasLogos } from '../../../data/patiosData';

const MarcaBreakdownItem = memo(({ marca, cantidad, isAlertCard, tooltipData }) => {
  const [tooltipPos, setTooltipPos] = useState(null);
  const rowRef = useRef(null);

  const showTooltip = useCallback(() => {
    if (!tooltipData || !rowRef.current) return;
    const rect = rowRef.current.getBoundingClientRect();
    setTooltipPos({
      top: rect.top + window.scrollY - 8,
      left: rect.left + window.scrollX,
    });
  }, [tooltipData]);

  const hideTooltip = useCallback(() => setTooltipPos(null), []);

  return (
    <div
      ref={rowRef}
      className="flex items-center justify-between text-xs"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      <div className="flex items-center min-w-0 flex-1 cursor-help">
        {marcasLogos[marca] && (
          <img src={marcasLogos[marca]} alt={marca} className="w-4 h-4 object-contain mr-1.5 flex-shrink-0" onError={(e) => { e.target.style.display='none'; }} />
        )}
        <span className={`truncate ${isAlertCard ? 'text-white' : 'text-gray-700'}`}>
          {marca}
        </span>
      </div>
      <span className={`font-semibold ml-2 flex-shrink-0 ${isAlertCard ? 'text-white' : 'text-gray-900'}`}>
        {cantidad}
      </span>

      {tooltipData && tooltipPos && ReactDOM.createPortal(
        <div
          style={{
            position: 'fixed',
            top: tooltipPos.top,
            left: tooltipPos.left,
            transform: 'translateY(-100%)',
            zIndex: 9999,
            pointerEvents: 'none',
          }}
        >
          <div className="bg-gray-900/95 backdrop-blur-sm text-white p-2.5 rounded-lg text-xs whitespace-nowrap shadow-xl border border-gray-700">
            <div className="font-semibold mb-1.5 pb-1 border-b border-gray-700 flex items-center gap-2">
              {marcasLogos[marca] && (
                <img src={marcasLogos[marca]} alt={marca} className="w-4 h-4 object-contain" onError={(e) => { e.target.style.display='none'; }} />
              )}
              {marca}
            </div>
            <div className="space-y-1">
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-1.5">
                  <Package className="w-3 h-3 text-white" />
                  <span className="text-gray-300">Inventario:</span>
                </div>
                <span className="font-medium text-white">{tooltipData.inventario || 0}</span>
              </div>
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-1.5">
                  <Activity className="w-3 h-3 text-white" />
                  <span className="text-gray-300">C. por llegar:</span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="font-medium text-white">{tooltipData.enTransito || 0}</span>
                  <span className="text-gray-500 w-2 text-center">+</span>
                </div>
              </div>
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-1.5">
                  <ShoppingCart className="w-3 h-3 text-white" />
                  <span className="text-gray-300">Facturados:</span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="font-medium text-white">{tooltipData.facturadosNoEntregados || 0}</span>
                  <span className="text-gray-500 w-2 text-center">+</span>
                </div>
              </div>
              <div className="border-t border-gray-700 pt-1 mt-1 flex justify-between gap-4">
                <span className="font-semibold text-gray-300">=</span>
                <span className="font-bold text-white tracking-wide">
                  {(tooltipData.inventario || 0) + (tooltipData.enTransito || 0) + (tooltipData.facturadosNoEntregados || 0)}
                </span>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}, (prev, next) =>
  prev.cantidad === next.cantidad &&
  prev.isAlertCard === next.isAlertCard &&
  prev.marca === next.marca &&
  prev.tooltipData === next.tooltipData
);

MarcaBreakdownItem.displayName = 'MarcaBreakdownItem';
export default MarcaBreakdownItem;
